// @flow

import Notifications from '../constants/Notifications';
import { Component } from '../jsti/core';
import AsyncRequest from '../classes/AsyncRequest';
import type { IAreFilterable } from '../interfaces/IAreFilterable';

export default class ReviewsFilters extends Component implements IAreFilterable {
  #requestUrl: string;
  filters: Object = {
    rating: '',
    sortBy: ''
  };

  #reviewPageNumber: number = 1;

  /**
   * Bind the component to an element
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp();
    this.addListener(Notifications.SORT, this.handleFilter);
    this.addListener(Notifications.PAGINATED, ({ data }: {data: Object}) => {
      this.#reviewPageNumber = data.pagination.current_page;
    });
  }

  /**
   * Setup properties & validation
   */
  setUp(): void {
    this.#requestUrl = this.el.dataset.request;

    if (!this.#requestUrl) {
      throw new Error('Request data is required');
    }
  }

  /**
   * Executes when the user filters/sorts
   */
  handleFilter({ data, reference }: Object): void {
    if (reference !== this.el.dataset.reference) return;

    if (data.name === 'rating') {
      if (data.value !== 'default') {
        this.filters.rating = data.value;
      } else {
        this.filters.rating = '';
      }
    }

    if (data.name === 'sort-by') {
      if (data.value !== 'default') {
        this.filters.sortBy = data.value;
      } else {
        this.filters.sortBy = '';
      }
    }

    this.sendRequest();
  }

  /**
   * Send an API request to retrieve new reviews
   */
  sendRequest(): void {
    const parameters: Object = {};

    if (this.filters.rating) {
      parameters.rating = this.filters.rating;
    }
    if (this.filters.sortBy) {
      parameters.sort_by = this.filters.sortBy;
    }

    AsyncRequest.get(`${this.#requestUrl}?page=1&rating=${this.filters.rating}&sorting=${this.filters.sortBy}`)
      .then(({ data }: Object) => {
        this.notify(Notifications.SORTED, { data: data, filters: this.filters });
      })
      .catch((error: any) => {
        console.error(error);
      });
  }
}
